var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhotoLibrary24DpE8EaedFill0Wght300Grad0Opsz24 = function SvgPhotoLibrary24DpE8EaedFill0Wght300Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    fill: "#e8eaed"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363.08-406.15h373.84L612.77-569.23l-95.08 121.54-62.77-77.69-91.84 119.23ZM250-260v-600h600v600H250Zm60-60h480v-480H310v480ZM110-120v-587.69h60V-180h527.69v60H110Zm200-680v480-480Z"
  })));
};
export default SvgPhotoLibrary24DpE8EaedFill0Wght300Grad0Opsz24;